// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__6zBBf","label":"Select_label__y9QvG","light":"Select_light__fmYNx","select":"Select_select__8BhOe","dark":"Select_dark__diM6Z"};